module.exports = __webpack_public_path__ + "static/media/close-icon.214aff25.svg";